import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SignInUpRedirectComponent } from './sign-in-up-redirect.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

export const routes = [
  { path: '', component: SignInUpRedirectComponent, pathMatch: 'full' }
]; 


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    SharedModule,
    MatDividerModule,
    MatButtonModule,
    MatDialogModule
  ],
  exports:[
    SignInUpRedirectComponent
  ],
  declarations: [
    SignInUpRedirectComponent
  ],
  entryComponents:[
    SignInUpRedirectComponent
  ],

})
export class SignInUpRedirectModule { }

  